import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { CartContext } from "./CartContext";
import { STORE } from "../config/store";
import { policyGroups } from "../config/policyNavigation";

function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 232 64" role="img" aria-label={STORE.brand}>
      <g className="brand-symbol" aria-hidden="true">
        <path d="M12 19c10-9 24-9 34 0-9 1-15 5-17 13-3-8-8-12-17-13Z" />
        <path d="M29 15v34M20 28h18" />
        <circle cx="29" cy="49" r="3" />
      </g>
      <text x="61" y="43">{STORE.brand}</text>
      <path className="brand-swish" d="M64 51c39 5 103 5 151-2" aria-hidden="true" />
    </svg>
  );
}

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);
  const itemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    const close = (event) => {
      if (event.key === "Escape") setMoreOpen(false);
      if (event.type === "mousedown" && !moreRef.current?.contains(event.target)) setMoreOpen(false);
    };
    document.addEventListener("keydown", close);
    document.addEventListener("mousedown", close);
    return () => {
      document.removeEventListener("keydown", close);
      document.removeEventListener("mousedown", close);
    };
  }, []);

  const toTop = () => {
    setMoreOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="site-header">
      <div className="announcement-bar">Curated everyday goods · {STORE.operatingRegion} · {STORE.currency}</div>
      <div className="header-main">
        <div className="header-left" aria-hidden="true" />
        <div className="header-center">
          <Link onClick={toTop} to="/" className="logo-link"><BrandMark /></Link>
        </div>
        <div className="header-right">
          <Link onClick={toTop} to="/cartpage" className="icon-btn" aria-label={`Shopping cart with ${itemCount} items`}>
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M20.5 20.5H3.5V9H20.5V20.5Z" stroke="currentColor" />
              <path d="M16.5 7.5C16.5 5.01 14.49 3 12 3S7.5 5.01 7.5 7.5" stroke="currentColor" />
            </svg>
            {itemCount > 0 && <span className="cart-count">{itemCount}</span>}
          </Link>
        </div>
      </div>
      <nav className="header-nav" aria-label="Primary navigation">
        <ul>
          <li><NavLink onClick={toTop} to="/shop">Curated Collections</NavLink></li>
          <li><NavLink onClick={toTop} to="/about">Our Story</NavLink></li>
          <li><NavLink onClick={toTop} to="/contact">Contact Us</NavLink></li>
          <li className="more-nav" ref={moreRef}>
            <button className="more-button" type="button" aria-expanded={moreOpen} aria-controls="more-menu" onClick={() => setMoreOpen((open) => !open)}>
              More <span aria-hidden="true">{moreOpen ? "−" : "+"}</span>
            </button>
            {moreOpen && (
              <div className="more-menu" id="more-menu">
                <NavLink className="all-policies-link" onClick={toTop} to="/policies">All policies</NavLink>
                <div className="more-menu-groups">
                  {policyGroups.map((group) => (
                    <section key={group.label} aria-labelledby={`menu-${group.label.replace(/\s+/g, "-")}`}>
                      <h2 id={`menu-${group.label.replace(/\s+/g, "-")}`}>{group.label}</h2>
                      <ul>{group.links.map(([label, to]) => <li key={to}><NavLink onClick={toTop} to={to}>{label}</NavLink></li>)}</ul>
                    </section>
                  ))}
                </div>
              </div>
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
